import { render } from "./Stationary.vue?vue&type=template&id=5916c1de"
import script from "./Stationary.vue?vue&type=script&lang=js"
export * from "./Stationary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__